import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import App from './App';
import PublicShareView from './views/PublicShareView';
import TermsView from './views/TermsView';
import PrivacyView from './views/PrivacyView';
import InformationList from './components/InformationList';
import AinekoLPView from './views/AinekoLPView';
import UserOrdersView from './views/UserOrdersView';
import OrderConfirmationBoardView from './views/OrderConfirmationBoardView';
import OrderReviewView from './views/OrderReviewView';
import MugDesignView from './views/MugDesignView';

/**
 * URLパスからmenuIdを取得してAppに渡すラッパー
 */
const AppWithMenuId: React.FC = () => {
  const { menuId } = useParams<{ menuId: string }>();

  // 数字のみの場合はmenuIdとして渡す
  const numericMenuId = menuId && /^\d+$/.test(menuId) ? parseInt(menuId, 10) : undefined;

  return <App menuIdFromUrl={numericMenuId} />;
};

const AppRouter: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/share/:frontendId" element={<PublicShareView />} />
        <Route path="/terms" element={<TermsView />} />
        <Route path="/privacy" element={<PrivacyView />} />
        <Route path="/information" element={<InformationList />} />
        <Route path="/design" element={<MugDesignView />} />
        <Route path="/design/" element={<MugDesignView />} />
        <Route path="/aineko" element={<AinekoLPView />} />
        <Route path="/aineko/" element={<AinekoLPView />} />
        <Route path="/aineko/orders" element={<UserOrdersView />} />
        <Route path="/aineko/orders/" element={<UserOrdersView />} />
        <Route path="/aineko/order/:orderId" element={<OrderConfirmationBoardView />} />
        <Route path="/aineko/order/:orderId/" element={<OrderConfirmationBoardView />} />
        <Route path="/aineko/order/:orderId/review" element={<OrderReviewView />} />
        <Route path="/aineko/order/:orderId/review/" element={<OrderReviewView />} />
        {/* メニューIDでのアクセス（例: /32/ または /32）または通常パス */}
        <Route path="/:menuId/" element={<AppWithMenuId />} />
        <Route path="/:menuId" element={<AppWithMenuId />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;